import { Component, EventEmitter, HostBinding, OnDestroy, Output } from '@angular/core';

import { CrmConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { CountdownTimerComponent } from '@frontend/sports/common/ui/countdown-timer';
import { DeviceService } from '@frontend/vanilla/core';

import { RewardTokensBannerService } from '../../services/reward-tokens-banner.service';

@Component({
    selector: 'bs-remind-me-later-notification',
    templateUrl: 'remind-me-later-notification.component.html',
    styleUrls: ['remind-me-later-notification.component.scss'],
    imports: [CountdownTimerComponent],
})
export class RemindMeLaterNotificationComponent implements OnDestroy {
    @Output() closeTokensReminder = new EventEmitter<void>();
    @Output() undoTokensReminder = new EventEmitter<void>();

    @HostBinding('class.reward-token-notification--mobile') get forMobile() {
        return this.deviceService.isMobile;
    }

    undoTimer: number;
    undoReminder = false;

    remindMeLaterMessages: {
        info: string;
        undo: string;
    };

    constructor(
        private tokensConfig: CrmConfig,
        private sitecore: Sitecore,
        private rewardTokensBannerService: RewardTokensBannerService,
        private deviceService: DeviceService,
    ) {
        this.remindMeLaterMessages = {
            info: interpolateDoubleBracesString(this.sitecore.crmTokens.banner.RemindMeLaterInfo, {
                link: this.sitecore.crmTokens.links.promotions.url || '',
            }),
            undo: this.sitecore.crmTokens.banner.Undo,
        };
        this.undoTimer = this.tokensConfig.tokens.remindMeLaterDuration;
    }

    closeReminderMeLater(): void {
        this.rewardTokensBannerService.setBetRewardBannerStorageKey(true);
        this.closeTokensReminder.emit();
    }

    undoReminderMeLater(): void {
        this.undoReminder = true;
        this.rewardTokensBannerService.setBetRewardBannerStorageKey(false);
        this.undoTokensReminder.emit();
    }

    ngOnDestroy(): void {
        if (!this.undoReminder) {
            this.closeReminderMeLater();
        }
    }
}
